import type { ReactElement } from "react";
import { ResponsiveContainer } from "recharts";
import { cn } from "@/lib/utils";

/**
 * ChartFrame — khung có chiều cao cố định cho một chart Recharts.
 *
 * Thay cho cặp `<div className="h-[240px]"><ResponsiveContainer height="100%">`.
 * Recharts cảnh báo `width(-1) and height(-1) of chart should be greater than 0`
 * khi cả hai chiều truyền vào là phần trăm: `-1` là `initialDimension` của nó,
 * và `warn()` chạy ngay trong thân render — trước khi `ResizeObserver` kịp đo
 * lần đầu. Điều kiện cảnh báo là OR trên hai chiều, nên chỉ cần một chiều là số
 * cụ thể là hết. Chiều rộng vẫn để `"100%"` nên chart vẫn co giãn theo cột.
 *
 * Chiều cao đi vào cả style của wrapper lẫn prop của container từ cùng một biến,
 * nên hai giá trị không thể lệch nhau — đó là lý do dùng component này thay vì
 * sửa tay từng chỗ.
 */
export function ChartFrame({
  height,
  className,
  children,
}: {
  /** Chiều cao vùng vẽ, px. */
  height: number;
  className?: string;
  /** Đúng một phần tử chart của Recharts (BarChart, LineChart, PieChart…). */
  children: ReactElement;
}) {
  return (
    <div className={cn("min-w-0", className)} style={{ height }}>
      <ResponsiveContainer width="100%" height={height}>
        {children}
      </ResponsiveContainer>
    </div>
  );
}
